const colorDefault = {
    marker: '#f50537',
    markerStroke: '#f50537',
    background: '#cccccc',
    text: '#727272',
    landscape: '#f2f2f2',
    road: '#ffffff',
    roadStroke: '#efefef',
};

const colorDark = {
    background: '#333333',
    text: '#ffffff',
    landscape: '#000',
    road: '#111111',
    roadStroke: '#222222', 
}

export const markerIcons = {
    default: {
        path: 'M41.5,20.8 C41.5,9.4 32.4,0.5 21,0.5 C9.6,0.5 0.5,9.4 0.5,20.8 C0.5,24.2 1.3,25.9 2.8,30.1 L2.8,30.1 L21,67.7 L39.2,30.1 C40.7,25.9 41.5,24.2 41.5,20.8 L41.5,20.8 Z M21,29.4 C16.1,29.4 12.3,25.6 12.3,20.9 C12.3,16.2 16.1,12.4 21,12.4 C25.9,12.4 29.7,16.2 29.7,20.9 C29.7,25.6 25.9,29.4 21,29.4 L21,29.4 Z',
        scale: 1,
        strokeOpacity: 0,
        fillColor: colorDefault.marker,
        fillOpacity: 1,
        anchor: { x: 20, y: 67 },
    },
    medium: {
        path: 'M41.5,20.8 C41.5,9.4 32.4,0.5 21,0.5 C9.6,0.5 0.5,9.4 0.5,20.8 C0.5,24.2 1.3,25.9 2.8,30.1 L2.8,30.1 L21,67.7 L39.2,30.1 C40.7,25.9 41.5,24.2 41.5,20.8 L41.5,20.8 Z M21,29.4 C16.1,29.4 12.3,25.6 12.3,20.9 C12.3,16.2 16.1,12.4 21,12.4 C25.9,12.4 29.7,16.2 29.7,20.9 C29.7,25.6 25.9,29.4 21,29.4 L21,29.4 Z',
        scale: 0.7,
        strokeWeight: 1,
        strokeColor: colorDefault.markerStroke,
        fillColor: colorDefault.marker,
        fillOpacity: 1,
        anchor: { x: 20, y: 67 },
    },
    small: {
        path: 'M41.5,20.8 C41.5,9.4 32.4,0.5 21,0.5 C9.6,0.5 0.5,9.4 0.5,20.8 C0.5,24.2 1.3,25.9 2.8,30.1 L2.8,30.1 L21,67.7 L39.2,30.1 C40.7,25.9 41.5,24.2 41.5,20.8 L41.5,20.8 Z M21,29.4 C16.1,29.4 12.3,25.6 12.3,20.9 C12.3,16.2 16.1,12.4 21,12.4 C25.9,12.4 29.7,16.2 29.7,20.9 C29.7,25.6 25.9,29.4 21,29.4 L21,29.4 Z',
        scale: 0.4,
        strokeWeight: 1,
        strokeColor: colorDefault.markerStroke,
        fillColor: colorDefault.marker,
        fillOpacity: 1,
        anchor: { x: 20, y: 67 },
    },
    mediumBlack: {
        path: 'M41.5,20.8 C41.5,9.4 32.4,0.5 21,0.5 C9.6,0.5 0.5,9.4 0.5,20.8 C0.5,24.2 1.3,25.9 2.8,30.1 L2.8,30.1 L21,67.7 L39.2,30.1 C40.7,25.9 41.5,24.2 41.5,20.8 L41.5,20.8 Z M21,29.4 C16.1,29.4 12.3,25.6 12.3,20.9 C12.3,16.2 16.1,12.4 21,12.4 C25.9,12.4 29.7,16.2 29.7,20.9 C29.7,25.6 25.9,29.4 21,29.4 L21,29.4 Z',
        scale: 0.7,
        strokeWeight: 1,
        strokeColor: '#000000',
        fillColor: '#000000',
        fillOpacity: 1,
        anchor: { x: 20, y: 67 },
    },
    mediumRed: {
        path: 'M41.5,20.8 C41.5,9.4 32.4,0.5 21,0.5 C9.6,0.5 0.5,9.4 0.5,20.8 C0.5,24.2 1.3,25.9 2.8,30.1 L2.8,30.1 L21,67.7 L39.2,30.1 C40.7,25.9 41.5,24.2 41.5,20.8 L41.5,20.8 Z M21,29.4 C16.1,29.4 12.3,25.6 12.3,20.9 C12.3,16.2 16.1,12.4 21,12.4 C25.9,12.4 29.7,16.2 29.7,20.9 C29.7,25.6 25.9,29.4 21,29.4 L21,29.4 Z',
        scale: 0.7,
        strokeWeight: 1,
        strokeColor: colorDefault.markerStroke,
        fillColor: colorDefault.marker,
        fillOpacity: 1,
        anchor: { x: 20, y: 67 },
    },
    circle: {
        path: 'M-10,0a10,10 0 1,0 20,0a10,10 0 1,0 -20,0 Z',
        scale: 0.4,
        strokeWeight: 1,
        strokeColor: colorDefault.markerStroke,
        fillColor: colorDefault.marker,
        fillOpacity: 1,
    },
    geoPos: {
      path: 'M20,0C8.95,0,0,8.95,0,20c0,11.05,8.95,20,20,20s20-8.95,20-20C40,8.95,31.05,0,20,0z M24.72,24.72h-9.44v-9.44h9.44V24.72z',
      scale: 0.7,
      strokeOpacity: 0,
      fillColor: '#000000',
      fillOpacity: 1,
      anchor: { x: 20, y: 20 },
    }
};

export const mapDefaultSettings = {
    backgroundColor: colorDefault.background,
    mapTypeControl: false,
    streetViewControl: false,
    zoom: 12,
    zoomControl: true,
    draggable: true
};

export const mapDefaultStyle = [
    // Background
    {
        stylers: [
            {
                color: colorDefault.background,
            },
        ],
    },

    // Landscape
    {
        featureType: 'landscape',
        stylers: [
            {
                color: colorDefault.landscape,
            },
        ],
    },

    // Road
    {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: colorDefault.road,
            },
            {
                "lightness": 10
            }
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: colorDefault.roadStroke,
            },
        ],
    },

    // Labels
    {
        elementType: 'labels.text.fill',
        stylers: [
            {
                // color: colorDefault.text,
                visibility: 'off',
            },
        ],
    },
    {
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: colorDefault.text,
                visibility: 'on',
            },
        ],
    },
    {
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },

    // Transit
    {
        featureType: 'transit',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },

    // Point of interest
    {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.attraction',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];

export const mapDarkSettings = {
    backgroundColor: colorDark.background,
    mapTypeControl: false,
    streetViewControl: false,
    zoom: 12,
    zoomControl: true,
    draggable: true
};

export const mapDarkStyle = [
    // Background
    {
        stylers: [
            {
                color: colorDark.background,
            },
        ],
    },

    // Landscape
    {
        featureType: 'landscape',
        stylers: [
            {
                color: colorDark.landscape,
            },
        ],
    },

    // Road
    {
        featureType: 'road',
        elementType: 'geometry.fill',
        stylers: [
            {
                color: colorDark.road,
            },
            {
                "lightness": 10
            }
        ],
    },
    {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [
            {
                color: colorDark.roadStroke,
            },
        ],
    },

    // Labels
    {
        elementType: 'labels.text.fill',
        stylers: [
            {
                // color: color.text,
                visibility: 'off',
            },
        ],
    },
    {
        elementType: 'labels.text.stroke',
        stylers: [
            {
                color: colorDark.text,
                visibility: 'on',
            },
        ],
    },
    {
        elementType: 'labels.icon',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },

    // Transit
    {
        featureType: 'transit',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },

    // Point of interest
    {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'poi.attraction',
        elementType: 'geometry.fill',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];